import React, { useMemo } from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';
import List from './List';
import { useTranslation } from 'react-i18next';
import useFiltersFromLocation from 'src/mtska-frontend-app-scaffolding/hooks/useFiltersFromLocation';

const Elletre = () => {
    const { t } = useTranslation();

    const [filters, setFilters] = useFiltersFromLocation();

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">

            <KPI
                title="Reports"
                icon="faChartSimple"
                dataProviderName={'statistics/total/countmine/bis/bi'}
            />
            <KPI
                title="Executive"
                icon="faGlobe"
                dataProviderName={'statistics/executive/countmine/bis/bi'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (newfilters) => setFilters({ filterModel: { ...newfilters } })
                }}
                filters={{
                    items: [{
                        field: "scope",
                        operator: "contains",
                        value: "executive"
                    }]
                }}
            />
            <KPI
                title="Area"
                icon="faGlobeStand"
                dataProviderName={'statistics/area/countmine/bis/bi'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (newfilters) => setFilters({ filterModel: { ...newfilters } })
                }}
                filters={{
                    items: [{
                        field: "scope",
                        operator: "contains",
                        value: "area"
                    }]
                }}
            />
            <KPI
                title="Shop"
                icon="faShop"
                dataProviderName={'statistics/area/countmine/bis/bi'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (newfilters) => setFilters({ filterModel: { ...newfilters } })
                }}
                filters={{
                    items: [{
                        field: "scope",
                        operator: "contains",
                        value: "shop"
                    }]
                }}
            />
        </Box>
        
        <List filters={filters} />
    </>, [filters])

}

export default Elletre;


